<template>
  <div>
    <b-form-group
      id="input-group-template"
      label="Trade template:"
      label-for="input-template"
    >
      <b-form-select
        id="input-template"
        v-model="template"
        :options="tradeTemplateOpts"
        required
      ></b-form-select>
    </b-form-group>

    <b-form-group
      id="input-group-direction"
      label="Direction:"
      label-for="input-direction"
    >
      <b-form-select
        id="input-direction"
        v-model="$v.tradeDraft.direction.$model"
        :options="directionOpts"
        required
      ></b-form-select>
      <div class="error" v-if="!$v.tradeDraft.direction.required">
        Field is required.
      </div>
    </b-form-group>
    <b-form-group
      id="input-group-startdate"
      label="Start date:"
      label-for="input-startdate"
    >
      <span class="datepicker-container">
        <Datepicker
          id="input-startdate"
          v-model="$v.tradeDraft.startDate.$model"
          name="Start date"
          format="yyyy-MM-dd"
        />
      </span>
      <div class="error" v-if="!$v.tradeDraft.startDate.required">
        Field is required.
      </div>
    </b-form-group>

    <b-form-group
      id="input-group-endDate"
      label="End date:"
      label-for="input-endDate"
    >
      <span class="datepicker-container">
        <Datepicker
          id="input-endDate"
          v-model="$v.tradeDraft.endDate.$model"
          name="End date"
          format="yyyy-MM-dd"
        />
      </span>
      <div class="error" v-if="!$v.tradeDraft.endDate.required">
        Field is required.
      </div>
    </b-form-group>

    <b-form-group
      id="input-group-notional"
      label="Notional:"
      label-for="input-notional"
    >
      <b-form-input
        type="number"
        id="input-notional"
        v-model.number="$v.tradeDraft.notional.$model"
        step="any"
        required
      ></b-form-input>
      <div class="error" v-if="!$v.tradeDraft.notional.required">
        Field is required.
      </div>
    </b-form-group>

    <b-form-group
      id="input-group-rate"
      label="Fixed rate:"
      label-for="input-rate"
    >
      <b-form-input
        type="number"
        id="input-rate"
        v-model.number="tradeDraft.rate"
        step="any"
        required
      ></b-form-input>
      <div class="error" v-if="!$v.tradeDraft.rate.required">
        Field is required.
      </div>
      <div class="error" v-if="!$v.tradeDraft.rate.between">
        Rate should be between 0 and 1.
      </div>
    </b-form-group>

    <!-- The modal to inform we cannot create the trade-->
    <b-modal ref="my-modal" ok-only
      >There are some error in the form. Please fix them to add the WhatIf
      trade</b-modal
    >
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { required, between } from "vuelidate/lib/validators";
import moment from "moment";
function newTradeDraft() {
  return {
    id: "",
    rate: 0.0,
    startDate: "",
    endDate: "",
    index: "",
    direction: "",
    notional: 0.0,
    currency: ""
  };
}

export default {
  data() {
    return {
      tradeDraft: newTradeDraft(),
      template: "TWD_FIXED_6M_TAIBOR_6M",
      tradeTemplateOpts: [
        {
          value: "TWD_FIXED_6M_TAIBOR_6M",
          text: "TWD Fixed Period 6 months vs TAIBOR6M",
          index: "TWD-TAIBOR-6M",
          currency: "TWD"
        }
      ],
      directionOpts: ["BUY", "SELL"]
    };
  },
  validations: {
    tradeDraft: {
      direction: { required },
      startDate: { required },
      endDate: { required },
      notional: { required },
      rate: { required, between: between(0, 1) }
    }
  },
  methods: {
    setTrade(trade) {
      const startDate = moment(trade.startDate, "YYYY-MM-DD").toDate();
      const endDate = moment(trade.endDate, "YYYY-MM-DD").toDate();
      this.tradeDraft.id = trade.id;
      this.tradeDraft.direction = trade.direction;
      this.tradeDraft.startDate = startDate;
      this.tradeDraft.endDate = endDate;
      this.tradeDraft.notional = trade.notional;
      this.tradeDraft.rate = trade.rate;
    },
    getTrade() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$refs["my-modal"].show();
        return null;
      } else {
        let opt = this.tradeTemplateOpts.find(
          tmplt => tmplt.value == this.template
        );
        this.tradeDraft.index = opt.index;
        this.tradeDraft.currency = opt.currency;

        let startDateWrapper = moment(this.tradeDraft.startDate);
        let endDateWrapper = moment(this.tradeDraft.endDate);
        let startDate = startDateWrapper.format("YYYY-MM-DD");
        let endDate = endDateWrapper.format("YYYY-MM-DD");
        let objCopy = JSON.parse(JSON.stringify(this.tradeDraft));
        objCopy.startDate = startDate;
        objCopy.endDate = endDate;
        return objCopy;
      }
    }
  },
  components: { Datepicker }
};
</script>

<style lang="scss" scoped>
.error {
  color: red;
}

span.datepicker-container {
  color: black !important;
}
</style>
